import React, { useEffect, useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import { useStyles } from '../style';
import { useForm } from "hooks/useForm";
import MultiSelect from "components/MultiSelect";
import LabCategoryService from "services/admin/masters/LabCategoryService";
import { buildQueryParams } from "utils/common";

const labCategoryServiceObj = new LabCategoryService();

const Category = (props) => {
    const classes = useStyles();
    const { bindGeneralInfo, labDetails } = props;
    const initialFormData = { // used to initialize the data
        labCategories: [],
    };
    // eslint-disable-next-line 
    const [categories, setCategories] = useState([]);


    const {
        handleChangeCustom,
        populateForm,
        data,
        errors,
    } = useForm({
        initialValues: initialFormData,
        validations: {
            labCategories: {
                required: {
                    value: true,
                    message: 'Atleast 1 lab category needs to be selected',
                },
            },
        },
    });

    useEffect(() => {
        const params = {
            is_deleted: false,
        }
        labCategoryServiceObj.getAllAddLabCategory(buildQueryParams(params)).then(response => {
            if (response) {
                setCategories(response.results);
            }
        }).catch(error => {
            console.log(error)
        })
    }, []);

    useEffect(() => {
        initialFormData.labCategories =  labDetails.labcategories;
        populateForm(initialFormData)
        //eslint-disable-next-line
    }, [labDetails])


    const handleBlur = (property, value) => {
        bindGeneralInfo(property, value);
    }

    return (
        <>
            <Grid item xs={6} className={classes.gridOutline}>
                <Typography color="textPrimary" className={classes.subheader}>Categories</Typography>
            </Grid>
            <Grid item xs={12} className={classes.gridOutline}>
                <MultiSelect
                    name={'labCategories'}
                    selected={labDetails?.labcategories}
                    onChange={handleChangeCustom}
                    title={'labCategories'}
                    data={categories}
                    error={errors['labCategories']}
                    isSearchHidden={true}
                    handleBlur={handleBlur}
                />
            </Grid>
        </>
    );
};


export default (Category);
